<template>
  <dashboard>
    <template v-slot:content>
      <loading v-show="!loading" />
      <section>
        <b-container fluid>
          <div class="header-elements align-items-center">
            <b-row class="mt-2">
              <b-col lg="12" md="12">
                <b-row class>
                  <b-col lg="7" md="7">
                    <h5 class="mt-2">{{Title}}</h5>
                  </b-col>
                  <b-col lg="5" md="5">
                    <b-button variant="dark" class="float-right" @click="backAdvice">Back to Advice</b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>

      <section class="fadein">
        <b-container fluid>
          <div class="customer-info table-dark-bg box-shadow mt-2 mb-3 p-4">
            <b-form v-on:submit.prevent>
              <b-row>
                <b-col lg="3" class="text-left">
                  <label for class="mb-0">Advice Number</label>
                  <b-input readonly :value="advice.advice_no" type="text"></b-input>
                </b-col>
                <b-col lg="3" class="text-left">
                  <label for class="mb-0">Advice Date</label>
                  <b-input readonly :value="advice.date" type="text"></b-input>
                </b-col>
                <b-col lg="3" class="text-left">
                  <label for class="mb-0">Supplier</label>
                  <b-input readonly :value="advice.supplier" type="text"></b-input>
                </b-col>
                <b-col lg="3" class="text-left">
                  <label for class="mb-0">Place of Origin</label>
                  <b-input readonly :value="advice.origin_from" type="text"></b-input>
                </b-col>
              </b-row>
            </b-form>
          </div>
        </b-container>
      </section>

      <section>
        <b-container fluid class="advice">
          <div>
            <div>
              <div class="customer-info table-dark-bg box-shadow p-2 mt-2 customer-info-data">
                <div
                  class="pill p-3 box-shadow mb-2 fade-in complete"
                  v-for="item in advice.grn_list"
                  :key="item.id"
                  style="display: inline-table; width: 100%;"
                >
                  <b-row class="align-items-center w-100" style="inline-table;">
                    <div class="text-left pl-4" style="table-cell; width: 15%;">
                      <label for class="mb-0">GRN Number</label>
                      <p>{{item.grn_no}}</p>
                    </div>
                    <div class="text-left" style="table-cell; width: 10%;">
                      <label for class="mb-0">Date</label>
                      <p>{{item.date}}</p>
                    </div>
                    <div class="text-left" style="table-cell; width: 10%;">
                      <label for class="mb-0">Received Qty</label>
                      <p>{{item.received_qty}}</p>
                    </div>
                    <div class="text-left" style="table-cell; width: 10%;">
                      <label for class="mb-0">Damaged Qty</label>
                      <p>{{item.damage_qty}}</p>
                    </div>
                    <div class="text-left" style="table-cell; width: 10%;">
                      <label for class="mb-0">Lost Qty</label>
                      <p>{{item.lost_qty}}</p>
                    </div>
                    <div class="text-left" style="table-cell; width: 15%;">
                      <label for class="mb-0">Remarks</label>
                      <p v-if="item.remarks != ''">{{item.remarks}}</p>
                      <p v-if="item.remarks == '' || item.remarks == null">-</p>
                    </div>
                    <div class="text-right" style="table-cell; width: 30%;">
                      <b-btn
                        class="btn-theme"
                        title="View Details"
                        @click="grnDetails(item.grn_no)"
                      >View Details</b-btn>
                    </div>
                  </b-row>
                </div>
              </div>
            </div>
          </div>
        </b-container>
      </section>
    </template>
  </dashboard>
</template>

<script>
import VSelect from "@alfsnd/vue-bootstrap-select";
import Dashboard from "../views/Dashboard";
import CatalogSearch from "../components/CatalogSearch";
import Loading from "../components/Loading";
import axios from "axios";
import { mapState } from "vuex";

export default {
  name: "advice-details",
  components: {
    Dashboard,
    CatalogSearch,
    VSelect,
    Loading
  },
  mounted() {
    this.adviceDetails();
  },
  computed: {
    ...mapState({
      state: state => state
    })
  },
  data() {
    return {
      Title: "Advice Details",
      loading: true,
      advice: []
    };
  },
  methods: {
    adviceDetails: function() {
      this.$loading = true;
      let data = {
        id: this.$route.params.id,
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        trans_from: this.state.system.trans_from,
        terminal_id: this.state.system.settings.terminal_id,
        url:"/vendor/advice-det"
      };
      axios
        .post(data.url, data)
        .then(response => {
          this.advice = response.data.data;
          this.$loading = false;
        })
        .catch(err => {
          this.$loading = false;
        });
    },
    backAdvice() {
      this.$router.push("/advice-list/");
    },
    grnDetails(val) {
      this.$router.push("/grn-detail/" + val);
    }
  }
};
</script>
<style lang="scss" scoped>
.custom-select {
  font-size: 13px;
}
.theme-dark .advice .customer-info-data {
  background: #202020;
  height: calc(100vh - 200px);
  @include custom-scrollbar();
  overflow-x: hidden;
  overflow-y: auto;
}
.text-muted {
  color: #c0c0c0 !important;
}
h5 {
  color: $grey-color;
}
.pill {
  background: $white-color;
  border-radius: 5px;
  position: relative;
  &:before {
    width: 7px;
    height: 100%;
    left: 0;
    top: 0;
    content: "";
    position: absolute;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
}
h4 {
  color: $mid-grey;
}
.pending.pill {
  &:before {
    background: $success-btn;
  }
}
.partial.pill {
  &:before {
    background: $dark-card-text;
  }
}
.complete.pill {
  &:before {
    background: $danger-btn;
  }
}
.advice .vb-invisible .vb-content {
  padding-right: 0px !important;
  box-sizing: border-box !important;
}
.theme-light .customer-info-data {
  background: #e0e0e0 !important;
}
.theme-light .customer-info .form-control:read-only {
  background-color: transparent !important;
  border: 1px #c0c0c0 solid !important;
  color: #808080;
}
</style>